(function ($) {
  $(function () {


    /*****
      Init age loading animitons
    *****/
    if ($(window).width() < 800) {
      // Less than 800
      AOS.init({
        once: true,
        delay: 100,
        duration: 450,
        useClassNames: true,
        offset: 10
      });
    } else {
      // More than 800
      AOS.init({
        once: true,
        delay: 200,
        duration: 750,
        useClassNames: true
      });
    }


    /*****
      Set some global variables
    *****/
    var template_url = $('#template_url').val();


    /*****
      iOS Viewport check
    *****/
    var isVHCheckNeeded = vhCheck();
    var hasVHCKeckValue = document.documentElement.style.getPropertyValue('--vh-offset');
    if (isVHCheckNeeded && hasVHCKeckValue) {
      $('body').addClass('use-ios-offset');
    }


    /*****
      Nav toggle
    *****/
    $('.site-header-menu-toggle').on('click', function (e) {
      e.preventDefault();
      $('html').attr('data-nav-state', $('html').attr('data-nav-state') == 'closed' ? 'open' : 'closed');
    });


    /*****
      Post single sidebar blocks
    *****/
    if ($('.news-single-right [data-rene-block]').length) {
      $(window).on('scroll', $.throttle(30, function () {
        var scrollTop = $(document).scrollTop() + ($(window).height() / 2);
        var positions = [];

        // Only allow changing afyerafter the user has scrolled 150px or more
        if ($(document).scrollTop() <= 150) {
          return;
        }

        $('.news-single-right [data-rene-block]').each(function () {
          $('.news-single-sidebar [data-rene-block]').removeClass('shown');
          positions.push({ position: $(this).position().top, element: $(this) });
        });

        var getClosest = closest(positions, scrollTop);
        $('.news-single-sidebar [data-id="' + getClosest.attr('data-id') + '"]').addClass('shown');
      }));

      function closest(array, number) {
        var num = 0;
        for (var i = array.length - 1; i >= 0; i--) {
          if (Math.abs(number - array[i].position) < Math.abs(number - array[num].position)) {
            num = i;
          }
        }
        return array[num].element;
      }


      // $('.news-single-sidebar [data-rene-block]').eq(0).css('opacity', 1);
      $('.news-single-sidebar [data-rene-block]').eq(0).addClass('shown');
    }


  });
})(jQuery);
